<template>
    <header>
        <router-link :to="{name: 'home-with-lang', params:{ lang }}" class="btn-icon">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 65"><path fill-rule="evenodd" d="M55.07 61.72c-.26 1.11-5.36 4.04-12.45 1.77-3.32-1.07-1.21-11.6-2.7-13.5-1.16-1.48-11.14-3.17-14.39.1-2.03 2.04.06 12.43-4.3 13.7-6.45 1.87-7.8.24-8.79-.05-1.89-.54-4.05-.8-3.86-12.14.18-11.3 1.3-19.76 1.3-19.76s-4.36 3.08-7.34 2.54c-2.97-.54-4.34-2.61 1.6-12.33C10.09 12.31 30.62-1.94 34.41.22c5.21 2.97 15.44 8.87 25.27 22.58 4.65 6.48 6.39 14.69-1.81 11.02-3.74-1.68-3.64-1.96-3.64-1.96s2.22 24.04.84 29.87v-.01Z" clip-rule="evenodd"/></svg>
            <span class="sr-only">Accueil</span>
        </router-link>
    </header>

    <div class="page-box manage-account">
        <h1 class="page-box-title">Zone parents</h1>

        <Tabs>
            <Tab title="Le chemin du coeur">
                <div id="game1" class="box">
                    <h2 class="tab-content-title">Reconnaissance des émotions</h2>

                    <div class="game1-stats">
                        <div>
                            <img class="thumbnail" src="/images/squirrel-joy.png" alt="Écureuil joyeux" />
                            <h3 class="stat-label">Joie</h3>
                            <p class="stat-score"><strong>11</strong>/12</p>
                        </div>
                        <div>
                            <img class="thumbnail" src="/images/squirrel-fear.png" alt="Écureuil effrayé" />
                            <h3 class="stat-label">Peur</h3>
                            <p class="stat-score">11/12</p>
                        </div>
                        <div>
                            <img class="thumbnail" src="/images/squirrel-sadness.png" alt="Écureuil triste" />
                            <h3 class="stat-label">Tristesse</h3>
                            <p class="stat-score"><strong>11</strong>/12</p>
                        </div>
                        <div>
                            <img class="thumbnail" src="/images/squirrel-calm.png" alt="Écureuil calme" />
                            <h3 class="stat-label">Calme</h3>
                            <p class="stat-score"><strong>11</strong>/12</p>
                        </div>
                    </div>
                </div>
            </Tab>
            <Tab title="Les amis plein d'astuces">
                <div id="game2">
                    <div class="box">
                        <h2 class="tab-content-title">7 parties jouées</h2>
                        <ul class="game2-stats">
                            <li>
                                <img class="thumbnail" src="/images/Melodie.png" alt="" />
                                <h3 class="stat-label">La visualisation</h3>
                                <span class="stat-score">1</span>
                            </li>
                            <li>
                                <img class="thumbnail" src="/images/Octave.png" alt="" />
                                <h3 class="stat-label">Le yoga</h3>
                                <span class="stat-score">4</span>
                            </li>
                            <li>
                                <img class="thumbnail" src="/images/Coda.png" alt="" />
                                <h3 class="stat-label">La méditation</h3>
                                <span class="stat-score">0</span>
                            </li>
                            <li>
                                <img class="thumbnail" src="/images/Alto.png" alt="" />
                                <h3 class="stat-label">La respiration profonde</h3>
                                <span class="stat-score">2</span>
                            </li>
                        </ul>
                    </div>
                    <div class="box">
                        <h2 class="tab-content-title">Le top 5 des musiques choisies</h2>
                        <ol class="game2-top5">
                            <li v-for="n in 5">
                                <SoundButton
                                    :id="n"
                                    file="/audio/sample-1.mp3"
                                />
                                <div class="choice-label">
                                    Prélude à l'après-midi d'un faune (DeBussy)
                                </div>
                                <button class="btn-icon btn-external" @click="() => openExternalLink(n)">
                                    <svg viewBox="0 0 32 31"><path fill="currentColor" d="M.308235 20.1517c-.629362.8717-.3318595 2.4365 2.239935 4.7562 2.5718 2.3196 4.11505 4.8001 5.04765 5.4139.93686.6102 1.79104 1.1506 5.64988-4.0096 3.8589-5.1602 6.6698-9.4511 6.6698-9.4511s3.6449 6.8876 4.9829 7.9615c1.338 1.0738 2.7307.8955 4.7046-5.2745 1.9696-6.1663 2.8039-17.58301.4707-18.40587C26.8581.00426011 22.5347.122062 12.9883.994435 8.47224 1.40536 5.96521 3.15007 8.92317 5.86454c2.95793 2.71447 5.54173 4.70396 5.54173 4.70396S2.30244 17.3929.31617 20.1523l-.007935-.0006Z" /></svg>
                                    <span class="sr-only">Ouvrir le lien</span>
                                </button>
                            </li>
                        </ol>
                    </div>
                </div>
            </Tab>
            <Tab title="Masques">

                <div id="rewards">
                    <Carousel v-bind="sliderSettings">
                        <Slide v-for="(reward, i) in rewards" :key="i">
                            <Card
                                :image="`/images/${reward.image}`"
                                :label="reward.name"
                            >
                                <template v-slot:button>
                                    <button class="btn-icon btn-print">
                                        <svg viewBox="0 0 65 83">
                                            <path d="M47.3193 1.84011C45.4252.672764 43.3754.348664 41.1938.862167L6.91133 8.93149c-2.18161.5135-3.87167 1.71791-5.07019 3.61321C.672212 14.4582.343525 16.5016.855076 18.6749L14.459 76.4709c.5115 2.1733 1.7172 3.8556 3.6112 5.0229 1.9237 1.1856 3.9496 1.5154 6.1552.9962l34.2824-8.0693c2.1816-.5135 3.8717-1.7179 5.0406-3.6314 1.1985-1.8953 1.5272-3.9387 1.0157-6.112L50.9602 6.88129c-.5116-2.17332-1.7172-3.8556-3.6409-5.04118Zm1.6964 45.47529c-.4772.7676-1.1656 1.2826-2.0766 1.497l-23.4943 5.53c-.887.2088-1.7273.0789-2.5024-.4192-.7694-.4742-1.285-1.1595-1.4929-2.0431-.208-.8837-.0763-1.7213.4249-2.4946.4771-.7677 1.1656-1.2826 2.0526-1.4914l23.4943-5.53c.887-.2088 1.7272-.0789 2.5263.4136.7695.4742 1.261 1.1651 1.469 2.0488.208.8836.0762 1.7212-.4009 2.4889Zm-3.3898-14.4012c-.4771.7676-1.1656 1.2825-2.0766 1.497l-23.4942 5.53c-.8871.2088-1.7273.0789-2.5024-.4192-.7695-.4743-1.285-1.1595-1.493-2.0432-.208-.8836-.0762-1.7212.4249-2.4945.4772-.7677 1.1657-1.2826 2.0527-1.4914l23.4942-5.53c.8871-.2088 1.7273-.0789 2.5264.4135.7694.4743 1.261 1.1652 1.469 2.0488.208.8837.0762 1.7213-.401 2.489Zm-3.3897-14.4013c-.4771.7677-1.1656 1.2826-2.0766 1.497L16.6653 25.54c-.887.2088-1.7272.0788-2.5023-.4193-.7695-.4742-1.285-1.1594-1.493-2.0431-.208-.8837-.0762-1.7213.4193-2.5185.4771-.7676 1.1712-1.2587 2.0583-1.4674l23.4942-5.5301c.887-.2088 1.7273-.0789 2.5207.3897.7695.4743 1.261 1.1652 1.4747 2.0727.2136.9075.0762 1.7213-.401 2.4889Z"/>
                                        </svg>
                                        <span class="sr-only">Imprimer</span>
                                    </button>
                                </template>
                            </Card>
                        </Slide>

                        <template #addons>
                            <div class="carousel-nav">
                                <navigation>
                                    <template #next>
                                        <svg width="49" height="39" viewBox="0 0 49 39">
                                            <path d="M2.04484 10.905C0.649836 11.235 -0.415163 13.0725 0.154837 17.655C0.724836 22.2375 0.117337 26.085 0.522337 27.5175C0.934836 28.95 1.32484 30.24 9.71733 28.4025C18.1098 26.565 24.6873 24.69 24.6873 24.69C24.6873 24.69 22.3548 34.815 22.7673 37.065C23.1798 39.315 24.7398 40.35 32.1123 35.85C39.4773 31.35 50.2773 20.565 48.6423 17.7C46.3923 13.7475 41.9298 10.095 31.5423 2.64751C26.6298 -0.877494 22.5798 -1.30499 23.1948 4.0125C23.8098 9.33 24.6798 13.59 24.6798 13.59C24.6798 13.59 6.46233 9.8625 2.05234 10.9125L2.04484 10.905Z" fill="currentColor"/>
                                        </svg>
                                        <span class="sr-only">Suivant</span>
                                    </template>
                                    <template #prev>
                                        <svg width="49" height="39" viewBox="0 0 49 39">
                                            <path d="M46.7618 10.905C48.1568 11.235 49.2218 13.0725 48.6518 17.655C48.0818 22.2375 48.6893 26.085 48.2843 27.5175C47.8718 28.95 47.4818 30.24 39.0893 28.4025C30.6968 26.565 24.1193 24.69 24.1193 24.69C24.1193 24.69 26.4518 34.815 26.0393 37.065C25.6268 39.315 24.0668 40.35 16.6943 35.85C9.32933 31.35 -1.47067 20.565 0.16433 17.7C2.41433 13.7475 6.87682 10.095 17.2643 2.64751C22.1768 -0.877494 26.2268 -1.30499 25.6118 4.0125C24.9968 9.33 24.1268 13.59 24.1268 13.59C24.1268 13.59 42.3443 9.8625 46.7543 10.9125L46.7618 10.905Z" fill="currentColor"/>
                                        </svg>
                                        <span class="sr-only">Précédent</span>
                                    </template>
                                </navigation>
                            </div>
                        </template>
                    </Carousel>
                </div>

            </Tab>
        </Tabs>
    </div>

    <nav class="nav-prevnext">
        <router-link :to="previousPage" class="btn-icon btn-prev">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 65 52"><path fill-rule="evenodd" d="M62.27 37.466c1.86-.44 3.28-2.89 2.52-9-.76-6.11.05-11.24-.49-13.15-.55-1.91-1.07-3.63-12.26-1.18s-19.96 4.95-19.96 4.95 3.11-13.5 2.56-16.5c-.55-3-2.63-4.38-12.46 1.62-9.82 6-24.22 20.38-22.04 24.2 3.001 5.27 8.95 10.14 22.8 20.07 6.55 4.7 11.95 5.27 11.13-1.82-.82-7.09-1.98-12.77-1.98-12.77s24.29 4.97 30.17 3.57l.01.01Z" clip-rule="evenodd"/></svg>
        </router-link>
    </nav>
</template>

<script>
    import Tabs from "../components/Tabs";
    import Tab from "../components/Tab";
    import Card from "../components/Card";
    import SoundButton from "../components/SoundButton";

    import { Carousel, Slide, Navigation } from 'vue3-carousel'
    import 'vue3-carousel/dist/carousel.css'

    export default {
        name: "ManageAccount",
        components: { Tabs, Tab, Card, Carousel, Slide, SoundButton, Navigation }
    }
</script>

<script setup>

    import { useMainStore } from "../stores/main";
    import { storeToRefs } from "pinia";
    import { computed } from "vue";

    let store = useMainStore();
    const { lang } = storeToRefs(store);

    const { rewards, getPreviousPage } = store;
    let previousPage = computed ( () => getPreviousPage());

    const sliderSettings = {
        itemsToShow: 4,
        snapAlign: 'start'
    };

    const openExternalLink = (id) => {
        alert('clicked ' + id);
    }

</script>
